'use strict';

var EventListenerOption = require('../lib/EventListenerOption.js');
var AFM = require('../lib/animate/FrameManager.js');
var Viewport = require('../lib/Viewport.js');

/**
 * @class
 */
var ScrollGallerySection = function(sectionElement) {
	this._elements = {
		section: sectionElement,
		content: sectionElement.querySelector(".scrollGallerySection__content"),
		contentSticky: sectionElement.querySelector(".scrollGallerySection__contentSticky"),
		images: sectionElement.querySelector(".scrollGallerySection__media")
	};

	this._onWinScrollOrResize = this._onWinScrollOrResize.bind(this);
	this._prepareDraw = this._prepareDraw.bind(this);
	this._draw = this._draw.bind(this);

	var listOpts = EventListenerOption.get();
	window.addEventListener('scroll', this._onWinScrollOrResize, listOpts);
	window.addEventListener('resize', this._onWinScrollOrResize, listOpts);
	window.addEventListener('load', this._onWinScrollOrResize, listOpts);
	AFM.on('read', this._prepareDraw);
	AFM.on('write', this._draw);
}

ScrollGallerySection.COMPONENT_STYLE_CLASS = 'scrollGallerySection';

/**
 * @private
*/
ScrollGallerySection.prototype._onWinScrollOrResize = function(event) {
	this._isDrawNeeded = true;
}


/**
 * @private
 */
ScrollGallerySection.prototype._prepareDraw = function() {
	if (this._isDrawNeeded === true) {
		this._contentFixedTop = undefined;
		this._contentWidth = undefined;
		var contentBCR = this._elements.content.getBoundingClientRect();
		var contentHeight = this._elements.contentSticky.getBoundingClientRect().height;

		if (contentHeight < Viewport.getHeight()) {
			var imagesBCR = this._elements.images.getBoundingClientRect();

			if (contentHeight < imagesBCR.height && Math.abs(imagesBCR.left - contentBCR.left) > 1) {
				var imagesTop = imagesBCR.top;
				var imagesBottom = imagesBCR.bottom;
				if (imagesTop < 0) {
					this._contentFixedTop = 0;
					this._contentWidth = contentBCR.width;
					if (imagesBottom - contentHeight <= 0) {
						this._contentFixedTop = imagesBottom - contentHeight;
					}
				}
			}
		}
	}
}

/**
 * @private
 */
ScrollGallerySection.prototype._draw = function() {
	if (this._isDrawNeeded === true) {
		this._isDrawNeeded = false;

		if (this._contentFixedTop !== undefined) {
			this._elements.contentSticky.style.position = "fixed";
			this._elements.contentSticky.style.top = this._contentFixedTop + "px";
		} else {
			this._elements.contentSticky.style.position = "";
			this._elements.contentSticky.style.top = "";
		}
		
		if (this._contentWidth !== undefined) {
			this._elements.contentSticky.style.width = this._contentWidth + "px";
		} else {
			this._elements.contentSticky.style.width = "";
		}
	}
}

module.exports = ScrollGallerySection;

